import React from 'react';
import PropTypes from 'prop-types';
import Button from '../ui/Button';
import { Link } from 'react-router-dom';

const CartItem = ({ item, onUpdateQuantity, onRemove }) => {
  const handleQuantityChange = (e) => {
    const value = e.target.value;
    // Ensure we get a valid number (minimum 1)
    const newQuantity = Math.max(1, parseInt(value) || 1);
    // Call onUpdateQuantity with just the new quantity
    // The CartPage will handle passing the item.id
    onUpdateQuantity(newQuantity);
  };

  const handleRemove = () => {
    onRemove();
  };

  return (
    <div className="py-4 px-4 sm:px-6 flex">
      {/* Product Image */}
      <div className="flex-shrink-0">
        <Link to={`/products/${item.id}`}>
          <img
            src={item.image?.url || item.image || '/placeholder-product.jpg'}
            alt={item.name}
            className="w-20 h-20 rounded-md object-cover"
            onError={(e) => {
              e.target.src = '/placeholder-product.jpg';
            }}
          />
        </Link>
      </div>

      {/* Product Info */}
      <div className="ml-4 flex-1">
        <div className="flex justify-between">
          <div>
            <Link 
              to={`/products/${item.id}`}
              className="text-lg font-medium text-gray-900 hover:text-pinkAccent"
            >
              {item.name}
            </Link>
            <p className="mt-1 text-sm text-gray-500 capitalize">{item.category}</p>
          </div>
          <p className="text-lg font-medium text-gray-900 ml-4">
            ${(item.price * item.quantity).toFixed(2)}
          </p>
        </div>

        <div className="flex items-center justify-between mt-4">
          {/* Quantity Selector */}
          <select
            value={item.quantity}
            onChange={handleQuantityChange}
            className="rounded-md border border-gray-300 text-base font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-pinkAccent focus:border-pinkAccent py-1 px-2"
          >
            {[...Array(Math.min(10, item.stock || 10)).keys()].map((x) => (
              <option key={x + 1} value={x + 1}>
                {x + 1}
              </option>
            ))}
          </select>

          {/* Remove Button */}
          <Button
            onClick={handleRemove}
            variant="danger"
            size="small"
          >
            Remove
          </Button>
        </div>
      </div>
    </div>
  );
};

CartItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    image: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string
      })
    ]),
    category: PropTypes.string,
    quantity: PropTypes.number.isRequired,
    stock: PropTypes.number
  }).isRequired,
  onUpdateQuantity: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};

export default CartItem;